import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface TwoFactorAuthProps {
  navigate: (screen: string) => void;
}
export function TwoFactorAuth({
  navigate
}: TwoFactorAuthProps) {
  const [isEnabled, setIsEnabled] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex-1 overflow-y-auto pb-safe bg-slate-50" data-id="element-3089">
      <TopBar title="Two-Factor Auth" showBack onBack={() => navigate('profile')} data-id="element-3090" />

      <div className="px-5 pt-6 pb-8" data-id="element-3091">
        <div className="flex flex-col items-center mb-8 text-center" data-id="element-3092">
          <div className="w-20 h-20 rounded-full bg-indigo-50 text-indigo-500 flex items-center justify-center mb-4 border-4 border-indigo-100" data-id="element-3093">
            <SmartphoneIcon className="w-10 h-10" data-id="element-3094" />
          </div>
          <h2 className="text-xl font-bold text-[#0D3B3B] mb-2" data-id="element-3095">
            Secure Your Account
          </h2>
          <p className="text-sm text-gray-500" data-id="element-3096">
            Add an extra layer of security to your account by enabling
            Two-Factor Authentication (2FA).
          </p>
        </div>

        <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm mb-8 flex items-center justify-between" data-id="element-3097">
          <div className="flex items-center gap-3" data-id="element-3098">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isEnabled ? 'bg-emerald-50 text-emerald-500' : 'bg-gray-100 text-gray-400'}`} data-id="element-3099">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-3100" />
            </div>
            <div data-id="element-3101">
              <h3 className="font-bold text-[#0D3B3B] text-sm" data-id="element-3102">
                Authenticator App
              </h3>
              <p className="text-xs text-gray-500 font-medium" data-id="element-3103">
                {isEnabled ? 'Enabled' : 'Not configured'}
              </p>
            </div>
          </div>
          <button onClick={() => setIsEnabled(!isEnabled)} className={`w-12 h-7 rounded-full relative transition-colors ${isEnabled ? 'bg-emerald-500' : 'bg-gray-300'}`} data-id="element-3104">
            <div className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-sm transition-all ${isEnabled ? 'right-1' : 'left-1'}`} data-id="element-3105"></div>
          </button>
        </div>

        {!isEnabled && <button onClick={() => setIsEnabled(true)} className="w-full bg-[#0D3B3B] hover:bg-[#092D2D] text-[#FFD700] font-bold py-4 rounded-xl transition-all shadow-lg shadow-[#0D3B3B]/20 active:scale-95 text-lg" data-id="element-3106">
            Set Up 2FA
          </button>}
      </div>
    </motion.div>;
}